import { Button, Modal } from '@cfm-media/pwa-ui-components';
import React, { useState } from 'react';

import { TransferMap } from './map';

const daysOfWeek = [
  'Sonntag',
  'Montag',
  'Dienstag',
  'Mittwoch',
  'Donnerstag',
  'Freitag',
  'Samstag',
];

export const TransferCard = ({ transfer, supplier }) => {
  if (!transfer) return null;

  const {
    create: createImageModal,
    destroy: destroyImageModal,
    modal: imageModal,
  } = useModal();

  const {
    create: createMapModal,
    destroy: destroyMapModal,
    modal: mapModal,
  } = useModal();

  const pickUpDate = new Date(transfer?.pickUp?.date);

  if (transfer?.pickUp?.time == 'Noch nicht verfügbar') {
    transfer.pickUp.time = null;
  }

  return (
    <div className="overflow-auto max-w-lg bg-white rounded-lg shadow-md p-4 font-extralight text-sm">
      <div className="flex flex-col h-full space-y-4">
        <div className="flex flex-col">
          <h2 className="font-semibold text-lg">{transfer?.title}</h2>
          {supplier != 'mts' && (
            <p className="text-gray-700">{transfer?.type}</p>
          )}
        </div>
        <div className="flex flex-col h-full ">
          <div className="flex space-x-4">
            <div className="flex flex-col h-full w-fit items-center">
              <div className="icon icon-bus text-xl text-brand-1" />
              {transfer?.dropOff && (
                <div className="border-r-2 border-spacing-4 border-dashed border-[#9FA2AA] w-0 h-full flex-1 my-2"></div>
              )}
            </div>
            <div className="flex flex-col w-full h-full pb-4">
              {transfer?.pickUp && (
                <div className="flex flex-col text-gray-700 space-y-1">
                  <div className="flex text-brand-1 font-semibold text-md items-center">
                    <h3 className=" ">Abholung</h3>
                  </div>
                  <div>
                    <p className=" font-semibold text-black">Datum:</p>
                    <p>
                      {transfer?.pickUp?.date
                        ? `${daysOfWeek[pickUpDate.getDay()]} -
                      ${pickUpDate.toLocaleDateString()}`
                        : 'Noch nicht verfügbar'}
                    </p>
                  </div>
                  {transfer?.pickUp?.time && (
                    <div>
                      <p className=" font-semibold text-black">Uhrzeit:</p>
                      <p>{transfer?.pickUp?.time + ' Uhr'} </p>
                    </div>
                  )}
                  {transfer?.pickUp?.address && (
                    <div>
                      <p className="font-semibold text-black">Abholpunkt:</p>
                      <p>{transfer.pickUp.address}</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          {transfer?.dropOff && (
            <div className="flex space-x-4">
              <div className="flex flex-col h-full w-fit items-center ">
                <div className="icon icon-destination text-xl text-brand-1" />
              </div>
              <div className="flex flex-col w-full h-full pb-2">
                <div className="flex flex-col text-gray-700">
                  <h3 className="font-semibold text-md text-brand-1">Ziel</h3>
                  {transfer?.dropOff?.hotelName ? (
                    <div>
                      <p className="font-semibold text-black">Ort:</p>
                      <p>{transfer.dropOff.hotelName}</p>
                    </div>
                  ) : null}
                  {transfer?.dropOff?.name ? (
                    <div>
                      <p className="font-semibold text-black">Ort:</p>
                      <p>{transfer.dropOff.name}</p>
                    </div>
                  ) : null}
                  {transfer?.dropOff?.address && (
                    <div>
                      <p className="font-semibold text-black">Addresse:</p>
                      <p>{transfer.dropOff.address}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="flex flex-col text-xs">
          <p className="text-black underline">Hinweis:</p>
          {!transfer.pickUp?.time ? (
            <p className="text-gray-700">{transfer.infoFallback}</p>
          ) : null}
          {transfer?.info ? (
            <p className="text-gray-700">{transfer.info}</p>
          ) : null}
        </div>

        {(transfer?.images.length || transfer?.pickUp?.location) && (
          <div className="flex flex-col w-full space-y-2 text-md">
            {transfer?.images.length ? (
              <Button
                className="w-full rounded-md"
                variant="primary"
                title="Bilder"
                onButtonClick={() => createImageModal()}
              />
            ) : null}
            {transfer?.pickUp?.location ? (
              <Button
                className="w-full rounded-md"
                variant="primary"
                title="Karte"
                onButtonClick={() => createMapModal()}
              />
            ) : null}
          </div>
        )}
      </div>
      <Modal
        className="overscroll-none"
        isOpen={imageModal.isVisible}
        setIsOpen={destroyImageModal}
        headline="Bilder"
        fullwidth
        bgBlur
        closeButton
      >
        {transfer?.images?.map((image) => (
          <img key={image} src={image} className="p-2" />
        ))}
      </Modal>

      <Modal
        className="overscroll-none"
        isOpen={mapModal.isVisible}
        setIsOpen={destroyMapModal}
        headline="Karte"
        fullwidth
        bgBlur
        closeButton
      >
        <TransferMap transfer={transfer} isVisible={mapModal.isVisible} />
      </Modal>
    </div>
  );
};

function useModal() {
  const defaultModal = {
    isVisible: false,
  };

  const [modal, setModal] = useState(defaultModal);

  const create = () => setModal({ isVisible: true });

  const destroy = setModal.bind(null, defaultModal);

  return { create, destroy, modal };
}
